import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { DxSelectBoxModule } from 'devextreme-angular/ui/select-box';
import { DxTextBoxModule } from 'devextreme-angular/ui/text-box';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxValidatorModule } from 'devextreme-angular/ui/validator';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import { DxTextAreaModule } from 'devextreme-angular/ui/text-area';
import { DxCheckBoxModule } from 'devextreme-angular/ui/check-box';
import { DxValidationGroupModule } from 'devextreme-angular/ui/validation-group';

import { SystemMessagesComponent } from '../shared/components/system-message/system-messages.component';

import { ModalModule } from 'ngx-modialog-7';
import { BootstrapModalModule } from 'ngx-modialog-7/plugins/bootstrap';
import { DxFileUploaderModule } from 'devextreme-angular/ui/file-uploader';

import { BecomeDealerFormComponent } from './components/become-dealer-form.component';
import { DevextremePhoneInputModule } from './../../custom_modules/devextreme-phone-input/devextreme-phone-input.module';

import { BecomeDealerTermsModal } from './components/become-dealer-terms.component';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { SharedToastrModule } from '../shared/refactored/toastr.module';
import { HttpCoreModule } from '../core/http.core.module';
import { DealerHttpService } from '../core/http/internal/dealer.http.service';

@NgModule({
    imports: [
        DxFileUploaderModule,
        BrowserModule,
        HttpClientModule,
        CommonModule,
        SharedToastrModule,
        HttpCoreModule.forRoot(),
        ModalModule.forRoot(),
        BootstrapModalModule,
        FormsModule,
        DxSelectBoxModule,
        DxTextBoxModule,
        DxButtonModule,
        DxCheckBoxModule,
        DxValidatorModule,
        DxLoadIndicatorModule,
        DxTextAreaModule,
        DxValidationGroupModule,
        DevextremePhoneInputModule,
        NgxSmartModalModule.forRoot()
    ],

    declarations: [
        BecomeDealerFormComponent,
        SystemMessagesComponent,
        BecomeDealerTermsModal
    ],

    providers: [
        Title,
        DealerHttpService
    ],

    bootstrap: [BecomeDealerFormComponent],

    entryComponents: [BecomeDealerTermsModal]
})

export class BecomeDealerModule { }



// WEBPACK FOOTER //
// ./src/app/become-dealer/become-dealer.module.ts